import { render, staticRenderFns } from "./Dashboards.vue?vue&type=template&id=5ec958cd&scoped=true"
import script from "./Dashboards.vue?vue&type=script&lang=ts"
export * from "./Dashboards.vue?vue&type=script&lang=ts"
import style0 from "./Dashboards.vue?vue&type=style&index=0&id=5ec958cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec958cd",
  null
  
)

export default component.exports